module.exports = __webpack_public_path__ + "img/homeCadre.749ce63d.png";